import React, { useState } from "react";
import { colors, Grid, Hidden, Typography } from "@material-ui/core";
import Barcode from "react-barcode/lib/react-barcode";
import { sto } from "../../../../../Context/InshData";
import BarcodeImg from "./BarcodeImg";

function BarcodeDate(props) {
    const { barcode, itemName, price, maqas, prody_date, expiry_date, AutoOptions, showLogo, showItem, data } = props;

    const width = 2;
    const hight = 30;

    return (
        <div justifyContent="center" style={{
            minWidth: `${maqas.wisthPaper}mm`,
            maxWidth: `${maqas.wisthPaper}mm`,
            minHeight: '20mm',
            textAlign: "center",
            backgroundColor: "#fff",
            paddingTop: `${maqas?.margnTop}mm`,
            paddingBottom: `${maqas?.margnBottom}mm`,
        }}>
            <BarcodeImg {...{ AutoOptions, showLogo, showItem, data }} />

            <div
                style={{
                    minWidth: '50mm',
                    paddingRight: '1mm',
                    paddingLeft: '1mm',
                    padding: '1mm',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    fontSize: '12px',
                    // textAlign:'center',
                    backgroundColor: '#fff',

                }}
            >
                <Barcode value={barcode} width={width} height={hight} />

            </div>
            <Grid
                container
                xs={12}
                style={{
                    fontSize: "8px",
                }}
            >
                <Grid item xs={6} style={{ direction: "rtl", textAlign: "center", fontWeight: "bold", maxLines: 1, fontSize: "1rem" }}>
                    {prody_date}
                </Grid>
                <Grid item xs={6} style={{ direction: "rtl", textAlign: "center", fontWeight: "bold", maxLines: 1, fontSize: "1rem" }}>
                    {" "}
                    {expiry_date}
                </Grid>
            </Grid>
        </div>
    );
}

export default BarcodeDate;
